import draggable from 'vuedraggable'
import recallReviewServices from '@/services/notisphere/recallReview'
import ProviderProductTierView from '@/views/share/provider-product-tier-view/index.vue'
import { convertFlatProductToTier } from '@/services/provider/communicationProduct'
export default {
    name: 'DetailsTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: Array,
            default: () => []
        },
        viewOnlyRecallFeed: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PdfViewer: require('@/components/core/PdfViewer.vue').default,
        CustomDatePicker: require('@/components/noti/DatePicker').default,
        ProviderProductTierView,
        draggable
    },
    data() {
        return {
            selectedDocument: null,
            selectedPdfDoc: null,
            pdfLoading: false,
            pdfAutoSelected: false,
            pdfError: null,
            pdfZoom: 100,
            pdfRotation: 0,
            pdfPage: 1,
            pdfNumPages: 0,
            isUploading: false,
            removingDocKey: null,
            pendingUploads: [],       // [{ clientId, file, filename, sizeBytes, iconClass, previewUrl }]
            pendingDeleteKeys: {},    // { [input_file]: true } — reactive lookup for docs marked for deletion
            editingField: null,
            editValue: '',
            tempData: {},
            originalRecallingFirmAddress: null,
            tempFieldValues: {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            },
            emailValidationError: false,
            recallTypeOptions: [
                { value: 'Correction', text: 'Correction' },
                { value: 'Removal', text: 'Removal' },
                { value: 'Field Safety Notice', text: 'Field Safety Notice' }
            ],
            fdaClassificationOptions: [
                { value: 'Class I', text: 'Class I' },
                { value: 'Class II', text: 'Class II' },
                { value: 'Class III', text: 'Class III' },
                { value: 'Not Yet Classified', text: 'Not Yet Classified' }
            ],
            recallCategoryOptions: [
                { value: 'Medical Devices', text: 'Medical Devices' },
                { value: 'Drugs', text: 'Drugs' },
                { value: 'Biologics', text: 'Biologics' },
                { value: 'Food', text: 'Food' }
            ],
            isVoluntaryOptions: [
                { value: 'Supplier Voluntary', text: 'Supplier Voluntary' },
                { value: 'Regulatory Mandate', text: 'Regulatory Mandate' }
            ],
            recallMetaData: null,
            // Product tier editing is owned by ProviderProductTierView
            isTierEditing: false,
            editingActionId: null,
            tempActionValue: '',
            isAddingNewAction: false,
            newActionValue: '',
            editingInstructionId: null,
            tempInstructionValue: '',
            isAddingNewInstruction: false,
            newInstructionValue: '',
            editingInstructionIndex: null, // For card-based editing
            tempInstructionCardValue: '',  // For card-based editing
            editingActionIndex: null, // For action card-based editing
            tempActionCardValue: '',  // For action card-based editing
            activeToasts: new Set(), // Track active toast messages
            isDragging: false,
            delayedDragging: false,
            editingResponseField: null, // Format: { fieldId, index }
            tempResponseFieldValue: '',
            tempResponseFieldLabel: '',
            actionsColumnDefs: [
                {
                    headerName: 'Action',
                    field: 'action',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm action-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            actionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            },
            instructionsColumnDefs: [
                {
                    headerName: 'Instruction',
                    field: 'instruction',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm instruction-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            instructionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 150,
                group: 'actions',
                ghostClass: 'ghost',
                disabled: this.isEditingDisabled
            }
        },
        actionsDragOptions() {
            return {
                animation: 150,
                group: 'recall-actions',
                ghostClass: 'ghost',
                disabled: this.isEditingDisabled
            }
        },
        instructionsDragOptions() {
            return {
                animation: 150,
                group: 'recall-instructions',
                ghostClass: 'ghost',
                disabled: this.isEditingDisabled
            }
        },
        documentOptions() {
            // Kept for backward compat with any external ref; mirrors documentDropdownItems.
            return this.documentDropdownItems
        },
        documentDropdownItems() {
            const latest = this.recallData?.latest_documents
            const originals = this.recallData?.documents
            const hasLatestDocumentsField = Object.prototype.hasOwnProperty.call(this.recallData || {}, 'latest_documents')
            let base = []
            // Presence-based source selection:
            // - legacy records (no latest_documents field): bootstrap from original documents
            // - curated records (latest_documents field exists): use latest_documents only, even when empty
            if (hasLatestDocumentsField) {
                if (Array.isArray(latest) && latest.length > 0) {
                    base = this._mapDocumentsToOptions(latest, false)
                }
            } else if (Array.isArray(originals) && originals.length > 0) {
                base = this._mapDocumentsToOptions(originals, true)
            }
            // Existing docs enriched with pending-delete state
            const existing = base.map(opt => ({
                ...opt,
                isPendingDelete: !!(opt.input_file && this.pendingDeleteKeys[opt.input_file]),
                isPendingUpload: false,
                icon: `<i class="${opt.iconClass}${this.pendingDeleteKeys[opt.input_file] ? ' text-muted' : ''}"></i>`
            }))
            // Pending uploads (not yet on server) appended at the end
            const pending = (this.pendingUploads || []).map((p, i) => ({
                id: `pending-${p.clientId}`,
                clientId: p.clientId,
                label: p.filename,
                url: p.previewUrl || '',
                input_file: null,
                size: p.sizeBytes || 0,
                iconClass: p.iconClass,
                icon: `<i class="${p.iconClass} text-primary"></i>`,
                isPendingUpload: true,
                isPendingDelete: false,
                isOriginal: false
            }))
            return [...existing, ...pending]
        },
        // True when latest_documents exists on the record (curated mode), regardless of array length.
        hasLatestDocuments() {
            return Object.prototype.hasOwnProperty.call(this.recallData || {}, 'latest_documents')
        },
        isEditing() {
            return !!(this.editingField ||
                     this.isTierEditing ||
                     this.editingActionId !== null ||
                     this.isAddingNewAction ||
                     this.editingInstructionId !== null ||
                     this.isAddingNewInstruction ||
                     this.editingResponseField !== null)
        },
        productListProxy() {
            const list = this.recallData?.recall_info?.product_list || []
            // Prefer in-place tiered data (ids stamped on load). Convert any remaining flat items once.
            return list.map((p, index) => {
                if (p && p.tier_1_data) return p
                const converted = convertFlatProductToTier(p)
                if (this.recallData?.recall_info?.product_list) {
                    this.$set(this.recallData.recall_info.product_list, index, converted)
                }
                return converted
            })
        },
        isMandatoryFieldsValid() {
            if (!this.recallData?.recall_info) return false
            const info = this.recallData.recall_info
            return true
        },
        hasValidationError() {
            return (fieldName) => {
                return this.validationErrors && this.validationErrors.includes(fieldName)
            }
        },
        // Check if editing should be disabled
        isEditingDisabled() {
            if (!this.recallData) return true

            const disabledStates = ['Duplicate', 'Pending Verification']
            return (
                disabledStates.includes(this.recallData.originality) ||
                this.recallData.status === 'PUBLISHED'
            )
        },
        isUploadDisabled() {
            if (!this.recallData || !this.recallData._id) return true
            const originality = this.recallData.originality
            const status = this.recallData.status
            return originality !== 'Original' || status !== 'PENDING'
        },
        actionsTableData() {
            if (!this.recallData?.recall_info?.actions) return []
            return this.recallData.recall_info.actions.map((action, index) => {
                const actionId = action.id || index
                return {
                    id: actionId,
                    action: action.value || action,
                    index: index,
                    isEditing: this.editingActionId === actionId
                }
            })
        },
        instructionsTableData() {
            if (!this.recallData?.recall_info?.instructions) return []
            return this.recallData.recall_info.instructions.map((instruction, index) => {
                const instructionId = instruction.id || index
                return {
                    id: instructionId,
                    instruction: instruction.value || instruction,
                    index: index,
                    isEditing: this.editingInstructionId === instructionId
                }
            })
        }
    },
    watch: {
        isEditing(newValue) {
            this.$emit('editing-state-changed', newValue)
        },
        isMandatoryFieldsValid(newValue) {
            this.$emit('validation-state-changed', newValue)
        },
        recallData: {
            handler(newValue, oldValue) {
                // Reset states when navigating to a different record
                if (newValue && oldValue && newValue.id !== oldValue.id) {
                    this.resetAllEditingStates()
                    this.pdfAutoSelected = false
                    this.selectedDocument = null
                    this.selectedPdfDoc = null
                    this.pdfError = null
                    this.pdfZoom = 100
                    this.pdfRotation = 0
                    this.pdfPage = 1
                    this.pdfNumPages = 0
                    this.resetPendingDocumentState()
                }
            },
            immediate: true,
            deep: false
        }
    },
    beforeDestroy() {
        this.resetPendingDocumentState()
    },
    methods: {
        onMove({ relatedContext, draggedContext }) {
            const relatedElement = relatedContext.element
            const draggedElement = draggedContext.element
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            )
        },

        onActionDragEnd() {
            this.isDragging = false

            // Re-assign sequence_number based on new order (same pattern as component.js)
            const reorderedActions = this.recallData.recall_info.actions.map((action, index) => ({
                ...action,
                order: index + 1
            }))

            // Update local data with new sequence numbers
            this.recallData.recall_info.actions = reorderedActions
            // Only emit if actions have actually been reordered
            this.$emit('action-reorder', this.recallData.recall_info.actions)
        },

        onInstructionDragEnd() {
            this.isDragging = false
            // Re-assign sequence_number based on new order
            const reorderedInstructions = this.recallData.recall_info.instructions.map((instruction, index) => ({
                ...instruction,
                order: index + 1
            }))

            // Update local data with new sequence numbers
            this.recallData.recall_info.instructions = reorderedInstructions
            // Only emit if instructions have actually been reordered
            this.$emit('instruction-reorder', this.recallData.recall_info.instructions)
        },

        // Validate NDC field - must be empty or exactly 11 digits
        validateNdc(ndc) {
            // if (!ndc || ndc.trim() === '') {
            //     return { valid: true }
            // }
            // const ndcValue = ndc.trim()
            // if (!/^\d{11}$/.test(ndcValue)) {
            //     return {
            //         valid: false,
            //         message: 'NDC must be exactly 11 digits'
            //     }
            // }
            return { valid: true }
        },

        // Handle NDC input to allow only numbers and max 11 digits
        handleNdcInput(event) {
            // let value = event.target.value
            // // Remove non-numeric characters
            // value = value.replace(/\D/g, '')
            // // Limit to 11 digits
            // if (value.length > 11) {
            //     value = value.substring(0, 11)
            // }
            // // Update the model
            // this.tempProductValues.ndc = value
        },

        // PDF Viewer Methods
        selectPdf(doc) {
            this.selectedPdfDoc = doc
            this.pdfAutoSelected = true
            this.pdfError = null
            this.pdfZoom = 100
            this.pdfRotation = 0
            this.pdfPage = 1
            this.pdfNumPages = 0

            // Show loading spinner for large files >10MB
            if (doc.size && doc.size > 10 * 1024 * 1024) {
                this.pdfLoading = true
            } else {
                this.pdfLoading = false
            }
        },

        handleDocumentSelection(documentId) {
            // Guard: pending-delete rows have their URL blanked by the dropdown template callers
            // and pending-upload rows point at an object URL, both of which we handle in the click hook.
            if (!documentId) return
            window.open(documentId, '_blank')
        },

        onDropdownItemClick(item, event) {
            // Guard: no-op for staged-for-delete rows unless the click came from the bin (handled below)
            if (item?.isPendingDelete) return
            if (item?.isPendingUpload) {
                // Preview the pending upload locally
                if (item.url) window.open(item.url, '_blank')
                return
            }
            if (item?.url) window.open(item.url, '_blank')
            if (event) event.stopPropagation()
        },

        // Bin click handler: toggles pending-delete state OR discards a pending upload.
        onDropdownBinClick(item, event) {
            if (event) {
                event.stopPropagation()
                event.preventDefault()
            }
            if (!item || this.isUploadDisabled) return
            if (item.isPendingUpload) {
                this.discardPendingUpload(item.clientId)
                return
            }
            if (item.isPendingDelete) {
                this.unstageDelete(item)
            } else {
                this.stageDelete(item)
            }
        },
        _mapDocumentsToOptions(docs, fromOriginals) {
            return docs.map((doc, index) => {
                const label = doc.filename || doc.input_file || `Document ${index + 1}`
                const iconClass = this._iconClassForFilename(doc.input_file)
                return {
                    id: index,
                    label,
                    url: doc.url,
                    input_file: doc.input_file,
                    size: doc.size || 0,
                    iconClass,
                    icon: `<i class="${iconClass}"></i>`,
                    isOriginal: !!fromOriginals
                }
            })
        },

        _iconClassForFilename(name) {
            const ext = ((name || '').split('.').pop() || '').toLowerCase()
            if (ext === 'pdf') return 'fas fa-file-pdf text-danger'
            if (['xls', 'xlsx', 'csv'].includes(ext)) return 'fas fa-file-excel text-success'
            if (['doc', 'docx'].includes(ext)) return 'fas fa-file-word text-primary'
            if (['jpg', 'jpeg', 'png'].includes(ext)) return 'fas fa-file-image text-warning'
            return 'fas fa-file-pdf text-secondary'
        },

        triggerUploadFile() {
            if (this.isUploadDisabled || this.isUploading) return
            if (this.$refs.documentUploadInput) {
                this.$refs.documentUploadInput.value = ''
                this.$refs.documentUploadInput.click()
            }
        },

        // Deferred upload: stage the file locally; commit happens on Save Changes.
        onDocumentFilesSelected(event) {
            const files = event.target?.files ? Array.from(event.target.files) : []
            if (!files.length) return

            // Client-side extension validation (server also validates on commit)
            const allowed = ['.pdf', '.xls', '.xlsx', '.csv', '.doc', '.docx', '.jpg', '.jpeg', '.png']
            const invalid = files.find(f => {
                const ext = ('.' + (f.name.split('.').pop() || '')).toLowerCase()
                return !allowed.includes(ext)
            })
            if (invalid) {
                this.$emit('upload-error', `File "${invalid.name}" is not an allowed type. Accepted: PDF, Excel, Word, CSV, JPEG, PNG.`)
                event.target.value = ''
                return
            }

            for (const file of files) {
                this.stageUpload(file)
            }
            this.$emit('unsaved-change')
            event.target.value = ''
        },

        stageUpload(file) {
            const clientId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
            let previewUrl = ''
            try {
                previewUrl = URL.createObjectURL(file)
            } catch (e) {
                previewUrl = ''
            }
            this.pendingUploads.push({
                clientId,
                file,
                filename: file.name,
                sizeBytes: file.size || 0,
                iconClass: this._iconClassForFilename(file.name),
                previewUrl
            })
        },

        discardPendingUpload(clientId) {
            const idx = this.pendingUploads.findIndex(p => p.clientId === clientId)
            if (idx === -1) return
            const [removed] = this.pendingUploads.splice(idx, 1)
            if (removed?.previewUrl) {
                try { URL.revokeObjectURL(removed.previewUrl) } catch (e) { /* ignore */ }
            }
            this.$emit('unsaved-change')
        },

        stageDelete(item) {
            if (!item?.input_file) return
            this.$set(this.pendingDeleteKeys, item.input_file, true)
            this.$emit('unsaved-change')
        },

        unstageDelete(item) {
            if (!item?.input_file) return
            this.$delete(this.pendingDeleteKeys, item.input_file)
            this.$emit('unsaved-change')
        },

        // Called by the parent modal at the top of handleSave.
        // Sequentially applies pending deletes then pending uploads; returns an oplog for changelog entries.
        // Returns { ok, opLog, failures, successfulDeleteKeys, successfulUploadClientIds } so the parent
        // can persist changelog entries for the ops that succeeded even when a subset failed.
        async commitDocumentChanges(recallId) {
            const opLog = []
            const successfulDeleteKeys = []
            const successfulUploadClientIds = []
            if (!recallId) return { ok: true, opLog, successfulDeleteKeys, successfulUploadClientIds }

            const deleteKeys = Object.keys(this.pendingDeleteKeys || {})
            const uploads = (this.pendingUploads || []).slice()

            if (deleteKeys.length === 0 && uploads.length === 0) {
                return { ok: true, opLog, successfulDeleteKeys, successfulUploadClientIds }
            }

            // Resolve friendly filename for each key from the current dropdown items (for changelog).
            const filenameByKey = {}
            for (const item of this.documentDropdownItems) {
                if (item.input_file) filenameByKey[item.input_file] = item.label
            }

            const failures = []

            // Helper: interpret an http helper response defensively.
            // Success = { ok: true, ... } (wrapped by ExtBaseController). Anything else is a failure,
            // EXCEPT a 404 from the delete endpoint which we treat as idempotent (already gone).
            const isSuccess = (resp) => {
                if (!resp) return false
                const err = resp.error
                if (!err) return true
                // Axios error surfaced via HttpResponse.error — treat 404 on delete as success (idempotent)
                const status = err?.response?.status || err?.status
                return status === 404
            }

            // 1) Deletes first — mirrors the on-disk semantic (remove before add)
            for (const key of deleteKeys) {
                try {
                    const resp = await recallReviewServices.deleteRecallDocument(recallId, key)
                    // eslint-disable-next-line no-console
                    console.debug('[commitDocumentChanges] delete response', { key, resp })
                    if (isSuccess(resp)) {
                        opLog.push({ action: 'delete', filename: filenameByKey[key] || key })
                        successfulDeleteKeys.push(key)
                    } else {
                        const msg = resp?.data?.m || resp?.error?.message || 'Failed to remove document.'
                        failures.push({ kind: 'delete', key, message: msg })
                    }
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error('[commitDocumentChanges] delete threw', { key, err })
                    failures.push({ kind: 'delete', key, message: err?.message || 'Failed to remove document.' })
                }
            }

            // 2) Uploads — one call for all files (existing endpoint supports multi-file FormData)
            if (uploads.length > 0) {
                try {
                    const resp = await recallReviewServices.uploadRecallDocuments(recallId, uploads.map(u => u.file))
                    // eslint-disable-next-line no-console
                    console.debug('[commitDocumentChanges] upload response', { count: uploads.length, resp })
                    if (isSuccess(resp)) {
                        for (const u of uploads) {
                            opLog.push({ action: 'add', filename: u.filename })
                            successfulUploadClientIds.push(u.clientId)
                        }
                    } else {
                        const msg = resp?.data?.m || resp?.error?.message || 'Failed to upload documents.'
                        failures.push({ kind: 'upload', message: msg })
                    }
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error('[commitDocumentChanges] upload threw', err)
                    failures.push({ kind: 'upload', message: err?.message || 'Failed to upload documents.' })
                }
            }

            if (failures.length > 0) {
                const msg = failures.map(f => `${f.kind}: ${f.message}`).join('; ')
                this.$emit('upload-error', `Some document changes failed — ${msg}. Please retry the failed ones.`)
                // Return ok:false but STILL surface opLog + successful IDs so the parent can persist
                // changelog entries for the ops that did succeed.
                return { ok: false, opLog, failures, successfulDeleteKeys, successfulUploadClientIds }
            }
            return { ok: true, opLog, successfulDeleteKeys, successfulUploadClientIds }
        },

        // Called by the parent after handleSave to clear only the ops that were persisted.
        clearCommittedPendingState({ successfulDeleteKeys = [], successfulUploadClientIds = [] } = {}) {
            for (const key of successfulDeleteKeys) {
                if (Object.prototype.hasOwnProperty.call(this.pendingDeleteKeys, key)) {
                    this.$delete(this.pendingDeleteKeys, key)
                }
            }
            if (successfulUploadClientIds.length > 0) {
                const idSet = new Set(successfulUploadClientIds)
                const kept = []
                for (const p of this.pendingUploads) {
                    if (idSet.has(p.clientId)) {
                        if (p.previewUrl) {
                            try { URL.revokeObjectURL(p.previewUrl) } catch (e) { /* ignore */ }
                        }
                    } else {
                        kept.push(p)
                    }
                }
                this.pendingUploads = kept
            }
        },

        // Discards all staged uploads and pending-delete marks. Called on save (post-success),
        // on cancel/close, and when navigating between recalls.
        resetPendingDocumentState() {
            for (const p of this.pendingUploads || []) {
                if (p.previewUrl) {
                    try { URL.revokeObjectURL(p.previewUrl) } catch (e) { /* ignore */ }
                }
            }
            this.pendingUploads = []
            this.pendingDeleteKeys = {}
        },

        onPdfLoaded() {
            this.pdfLoading = false
            this.pdfError = null
        },

        onPdfError(error) {
            this.pdfLoading = false
            this.pdfError = 'Error: Document cannot be previewed. Please check file integrity or download to view locally.'
            console.error('PDF loading error:', error)
        },

        zoomIn() {
            if (this.pdfZoom < 200) {
                this.pdfZoom += 25
            }
        },

        zoomOut() {
            if (this.pdfZoom > 50) {
                this.pdfZoom -= 25
            }
        },

        resetZoom() {
            this.pdfZoom = 100
        },

        rotateLeft() {
            this.pdfRotation = (this.pdfRotation - 90 + 360) % 360
        },

        rotateRight() {
            this.pdfRotation = (this.pdfRotation + 90) % 360
        },

        nextPage() {
            if (this.pdfPage < this.pdfNumPages) {
                this.pdfPage++
            }
        },

        prevPage() {
            if (this.pdfPage > 1) {
                this.pdfPage--
            }
        },

        onNumPages(numPages) {
            this.pdfNumPages = numPages
        },

        downloadDocument() {
            if (this.selectedPdfDoc && this.selectedPdfDoc.url) {
                window.open(this.selectedPdfDoc.url, '_blank')
            }
        },

        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return 'Unknown size'
            const units = ['B', 'KB', 'MB', 'GB']
            let size = bytes
            let unitIndex = 0
            while (size >= 1024 && unitIndex < units.length - 1) {
                size /= 1024
                unitIndex++
            }
            return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
        },

        /**
         * Extracts the calendar date (YYYY-MM-DD) from various date formats.
         * This is the core function that ensures timezone-independent date handling.
         * @param {Date|string|object} dateValue - The date value (Date object, ISO string, or MongoDB $date object)
         * @returns {object|null} - { year, month, day } or null
         */
        extractDateComponents(dateValue) {
            if (!dateValue) return null

            // Handle MongoDB $date format: { "$date": "2022-10-18T00:00:00.000Z" }
            const value = dateValue?.$date || dateValue

            if (!value) return null

            // If it's a string, extract YYYY-MM-DD directly (no timezone conversion)
            if (typeof value === 'string') {
                const match = value.match(/(\d{4})-(\d{2})-(\d{2})/)
                if (match) {
                    return {
                        year: parseInt(match[1], 10),
                        month: parseInt(match[2], 10),
                        day: parseInt(match[3], 10)
                    }
                }
            }

            // If it's a Date object, extract LOCAL date components
            // (Date picker returns Date at local midnight)
            if (value instanceof Date && !isNaN(value.getTime())) {
                return {
                    year: value.getFullYear(),
                    month: value.getMonth() + 1,
                    day: value.getDate()
                }
            }

            return null
        },

        /**
         * Converts a date to API format (YYYY-MM-DDTHH:mm:ss.SSSZ).
         * Extracts the calendar date and formats as UTC midnight.
         */
        formatDateForAPI(date) {
            const components = this.extractDateComponents(date)
            if (!components) return null

            const { year, month, day } = components
            const monthStr = String(month).padStart(2, '0')
            const dayStr = String(day).padStart(2, '0')

            return `${year}-${monthStr}-${dayStr}T00:00:00.000Z`
        },

        /**
         * Formats a date for display (MM/DD/YYYY).
         * Extracts the calendar date directly without timezone conversion.
         */
        formatDateForDisplay(date) {
            const components = this.extractDateComponents(date)
            if (!components) return '-'

            const { year, month, day } = components
            const monthStr = String(month).padStart(2, '0')
            const dayStr = String(day).padStart(2, '0')

            return `${monthStr}/${dayStr}/${year}`
        },

        /**
         * Converts an API date to a Date object suitable for the date picker.
         * Creates Date at LOCAL NOON (12:00) to avoid timezone boundary issues.
         * Using noon gives a 12-hour buffer in either direction for timezone shifts.
         */
        convertDateForPicker(dateValue) {
            const components = this.extractDateComponents(dateValue)
            if (!components) return null

            const { year, month, day } = components
            // Create date at NOON LOCAL time to avoid midnight timezone edge cases
            return new Date(year, month - 1, day, 12, 0, 0)
        },

        // Parse date string to Date object at UTC midnight (legacy - kept for compatibility)
        parseAsUTCDate(dateString) {
            if (!dateString) return null
            try {
                // Handle MongoDB $date format
                const value = dateString?.$date || dateString
                const dateMatch = String(value).match(/(\d{4})-(\d{2})-(\d{2})/)
                if (dateMatch) {
                    const year = parseInt(dateMatch[1], 10)
                    const month = parseInt(dateMatch[2], 10) - 1 // Month is 0-indexed
                    const day = parseInt(dateMatch[3], 10)
                    return new Date(Date.UTC(year, month, day))
                }
                return null
            } catch (error) {
                return null
            }
        },

        getStatusClass(status) {
            const statusMap = {
                'PUBLISHED': 'badge-success',
                'PENDING': 'badge-warning',
            }
            return statusMap[status] || 'badge-secondary'
        },

        showToast(message, options = {}) {
            // Create a unique key for this toast message
            const toastKey = `${message}_${options.variant || 'default'}`
            // Check if this toast is already showing
            if (this.activeToasts.has(toastKey)) {
                return
            }
            // Add to active toasts
            this.activeToasts.add(toastKey)
            // Show the toast
            this.$bvToast.toast(message, {
                title: options.title || 'Notification',
                variant: options.variant || 'info',
                solid: true,
                toaster: 'b-toaster-top-center',
                autoHideDelay: options.autoHideDelay || 3000,
                ...options
            })
            // Remove from active toasts after it's hidden
            setTimeout(() => {
                this.activeToasts.delete(toastKey)
            }, (options.autoHideDelay || 3000) + 500)
        },

        openDocument(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },
        fetchActionsData(params) {
            // For simple display-only grid with clientSide data
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.actionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onActionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            // Get the actual data from the row
            const rowData = this.actionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditAction(rowData.id, rowData.index)
            } else if (action === 'save') {
                // Get the current value from the input field before saving
                const input = document.querySelector('.action-edit-input')
                if (input) {
                    this.tempActionValue = input.value
                }
                this.saveEditAction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditAction()
            } else if (action === 'delete') {
                this.deleteAction(rowData.index)
            }
        },
        startEditAction(actionId, index) {
            this.editingActionId = actionId
            const action = this.recallData.recall_info.actions[index]
            // Handle both object format {id, value} and string format
            if (typeof action === 'object' && action.value) {
                this.tempActionValue = action.value
            } else {
                this.tempActionValue = action
            }
            // Refresh grid to show input textbox
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    // Focus the input after rendering
                    this.$nextTick(() => {
                        const input = document.querySelector('.action-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            // Add event listeners
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditActionFromInput(actionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditAction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempActionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditAction(actionId, index) {
            if (!this.tempActionValue || !this.tempActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentAction = this.recallData.recall_info.actions[index]
            let updatedAction
            if (typeof currentAction === 'object' && currentAction.id) {
                updatedAction = {
                    id: currentAction.id,
                    value: this.tempActionValue
                }
            } else {
                updatedAction = {
                    value: this.tempActionValue
                }
            }
            this.$emit('action-update', { id: actionId, index, action: updatedAction })
            // Wait for parent to update data first, then clear editing state and refresh grid
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingActionId = null
                    this.tempActionValue = ''
                    this.$nextTick(() => {
                        this.refreshActionsGrid()
                    })
                })
            })
        },
        saveEditActionFromInput(actionId, index, value) {
            this.tempActionValue = value
            this.saveEditAction(actionId, index)
        },
        cancelEditAction() {
            this.editingActionId = null
            this.tempActionValue = ''
            this.refreshActionsGrid()
        },
        deleteAction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.$nextTick(() => {
                            this.refreshActionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewAction() {
            this.isAddingNewAction = true
            this.newActionValue = ''
        },
        saveNewAction() {
            if (!this.newActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const actions = this.recallData?.recall_info?.actions || []
            const hasOrderField = actions.length > 0 && actions.some(action => action.order !== undefined)
            const newAction = { value: this.newActionValue }
            if (hasOrderField) {
                const maxOrder = Math.max(...actions.map(action => action.order || 0))
                newAction.order = maxOrder + 1
            }
            this.$emit('action-add', newAction)
            this.cancelNewAction()
            this.refreshActionsGrid()
        },
        cancelNewAction() {
            this.isAddingNewAction = false
            this.newActionValue = ''
        },
        refreshActionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        // Instructions methods
        fetchInstructionsData(params) {
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.instructionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onInstructionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            const rowData = this.instructionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditInstruction(rowData.id, rowData.index)
            } else if (action === 'save') {
                const input = document.querySelector('.instruction-edit-input')
                if (input) {
                    this.tempInstructionValue = input.value
                }
                this.saveEditInstruction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditInstruction()
            } else if (action === 'delete') {
                this.deleteInstruction(rowData.index)
            }
        },
        startEditInstruction(instructionId, index) {
            this.editingInstructionId = instructionId
            const instruction = this.recallData.recall_info.instructions[index]
            if (typeof instruction === 'object' && instruction.value) {
                this.tempInstructionValue = instruction.value
            } else {
                this.tempInstructionValue = instruction
            }
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$nextTick(() => {
                        const input = document.querySelector('.instruction-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditInstructionFromInput(instructionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditInstruction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempInstructionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditInstruction(instructionId, index) {
            if (!this.tempInstructionValue || !this.tempInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentInstruction = this.recallData.recall_info.instructions[index]
            let updatedInstruction
            if (typeof currentInstruction === 'object' && currentInstruction.id) {
                updatedInstruction = {
                    id: currentInstruction.id,
                    value: this.tempInstructionValue
                }
            } else {
                updatedInstruction = {
                    value: this.tempInstructionValue
                }
            }
            this.$emit('instruction-update', { id: instructionId, index, instruction: updatedInstruction })
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingInstructionId = null
                    this.tempInstructionValue = ''
                    this.$nextTick(() => {
                        this.refreshInstructionsGrid()
                    })
                })
            })
        },
        saveEditInstructionFromInput(instructionId, index, value) {
            this.tempInstructionValue = value
            this.saveEditInstruction(instructionId, index)
        },
        cancelEditInstruction() {
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.refreshInstructionsGrid()
        },
        deleteInstruction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.$nextTick(() => {
                            this.refreshInstructionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewInstruction() {
            this.isAddingNewInstruction = true
            this.newInstructionValue = ''
        },
        saveNewInstruction() {
            if (!this.newInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const instructions = this.recallData?.recall_info?.actions || []
            const hasInstructionField = instructions.length > 0 && instructions.some(instruction => instruction.order !== undefined)
            const newInstruction = { value: this.newInstructionValue }
            if (hasInstructionField) {
                const maxOrder = Math.max(...instructions.map(instruction => instruction.order || 0))
                newInstruction.order = maxOrder + 1
            }
            // const newInstruction = { value: this.newInstructionValue }
            this.$emit('instruction-add', newInstruction)
            this.cancelNewInstruction()
            this.refreshInstructionsGrid()
        },
        cancelNewInstruction() {
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''
        },
        refreshInstructionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        getInstructionsText(instructions) {
            if (!instructions || instructions.length === 0) return ''
            // Convert array of instructions to newline-separated text
            return instructions.map(item => item.value || item).join('\n')
        },

        startEdit(field, currentValue) {
            this.editingField = field
            this.emailValidationError = false
            if (field === 'recall_date') {
                // For date field, convert for picker display
                this.tempFieldValues[field] = this.convertDateForPicker(currentValue)
            } else if (field === 'isVoluntary') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || 'Supplier Voluntary'
            } else if (field === 'recalling_firm_address') {
                // Store the original address for comparison
                this.originalRecallingFirmAddress = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
                // For recalling_firm_address, handle object with nested properties
                this.tempFieldValues[field] = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            }
            else if (field === 'urgent') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || false
            } else {
                this.tempFieldValues[field] = currentValue || ''
            }
        },

        cancelEdit() {
            this.editingField = null
            this.emailValidationError = false
            // Clear all temp values
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: ''
            }
        },

        saveEdit(field) {
            // Validate email if the field is response_email
            if (field === 'response_email' && this.tempFieldValues[field]) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(this.tempFieldValues[field])) {
                    this.emailValidationError = true
                    this.showToast('Please enter a valid email address', {
                        title: 'Invalid Email',
                        variant: 'danger'
                    })
                    return
                }
            }

            this.emailValidationError = false
            // Handle recalling_firm_address separately to detect individual field changes
            if (field === 'recalling_firm_address') {
                const oldAddress = this.originalRecallingFirmAddress || {}
                const newAddress = this.tempFieldValues[field]
                // Check each address field for changes and emit individually
                const addressFields = ['street', 'town', 'state', 'zipcode', 'country']
                let hasChanges = false
                addressFields.forEach(addressField => {
                    const oldValue = oldAddress[addressField] || ''
                    const newValue = newAddress[addressField] || ''
                    if (oldValue !== newValue) {
                        hasChanges = true
                        this.$emit('field-update', {
                            field: `recalling_firm_address.${addressField}`,
                            value: newValue,
                            oldValue: oldValue
                        })
                    }
                })
                if (!hasChanges) {
                    this.showToast('No changes detected', {
                        title: 'Info',
                        variant: 'info',
                        autoHideDelay: 2000
                    })
                }
                // Clear the stored original address
                this.originalRecallingFirmAddress = null
            } else {
                // Check if value has actually changed before emitting update
                const currentValue = this.recallData?.recall_info?.[field]
                let hasChanged = false

                if (field === 'recall_date') {
                    // Compare dates by converting both to API format strings
                    const oldDateStr = currentValue ? this.formatDateForAPI(currentValue) : null
                    const newDateStr = this.tempFieldValues[field] ? this.formatDateForAPI(this.tempFieldValues[field]) : null
                    hasChanged = oldDateStr !== newDateStr
                } else {
                    // For non-date fields, simple comparison
                    hasChanged = currentValue !== this.tempFieldValues[field]
                }

                if (hasChanged) {
                    // For date fields, convert to API format before emitting
                    let valueToEmit = this.tempFieldValues[field]
                    let oldValueToEmit = currentValue

                    if (field === 'recall_date') {
                        valueToEmit = this.formatDateForAPI(this.tempFieldValues[field])
                        oldValueToEmit = currentValue ? this.formatDateForAPI(currentValue) : null
                    }

                    // Emit the save event with field name and new value
                    this.$emit('field-update', {
                        field: field,
                        value: valueToEmit,
                        oldValue: oldValueToEmit
                    })
                }
            }
            this.editingField = null
            // Clear the temp value after saving
            if (field === 'recall_date') {
                this.tempFieldValues[field] = null
            } else if (field === 'urgent') {
                this.tempFieldValues[field] = false
            } else if (field === 'recalling_firm_address') {
                this.tempFieldValues[field] = {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            } else {
                this.tempFieldValues[field] = ''
            }
        },

        // Card-based instruction methods
        startEditInstructionCard(index, instruction) {
            this.editingInstructionIndex = index
            this.tempInstructionCardValue = instruction.value || ''
        },

        saveInstructionCard(index) {
            if (!this.tempInstructionCardValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedInstruction = {
                ...this.recallData.recall_info.instructions[index],
                value: this.tempInstructionCardValue
            }

            this.$emit('instruction-update', { index, instruction: updatedInstruction })

            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
            this.refreshInstructionsGrid()
        },

        cancelEditInstructionCard() {
            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
        },

        deleteInstructionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.refreshInstructionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Action card methods for responsive table
        startEditActionCard(index, action) {
            this.editingActionIndex = index
            this.tempActionCardValue = action.value || ''
        },

        saveActionCard(index) {
            if (!this.tempActionCardValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedAction = {
                ...this.recallData.recall_info.actions[index],
                value: this.tempActionCardValue
            }

            this.$emit('action-update', { index, action: updatedAction })

            this.editingActionIndex = null
            this.tempActionCardValue = ''
            this.refreshActionsGrid()
        },

        cancelEditActionCard() {
            this.editingActionIndex = null
            this.tempActionCardValue = ''
        },

        deleteActionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.refreshActionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Product tier accordion is handled by ProviderProductTierView
        onTierEditingStateChanged(isEditing) {
            this.isTierEditing = !!isEditing
        },

        onTierChange(change) {
            if (!change) return
            if (change.type === 'add') {
                this.$emit('product-add', change.product)
            } else if (change.type === 'delete') {
                this.$emit('product-delete', change.index)
            } else if (change.type === 'update') {
                this.$emit('product-update-all', { index: change.index, product: change.product })
            }
        },

        resetAllEditingStates() {
            // Reset field editing
            this.editingField = null
            this.emailValidationError = false
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            }

            // Reset product editing (tier UI lives in ProviderProductTierView)
            this.isTierEditing = false
            this.editingProduct = null
            this.editingProductIndex = null
            this.tempProductValues = {}

            // Reset action editing
            this.editingActionId = null
            this.tempActionValue = ''
            this.isAddingNewAction = false
            this.newActionValue = ''

            // Reset instruction editing
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''

            // Reset response field editing
            this.editingResponseField = null
            this.tempResponseFieldLabel = ''
            this.tempResponseFieldValue = ''
        },

        // Response Form Methods
        updateResponseField(fieldId, index, value) {
            // Emit update event to parent for text/signature fields
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: value
            })
        },

        updateResponseDateField(fieldId, index, dateValue) {
            // Convert date to API format and emit update
            const formattedDate = dateValue ? this.formatDateForAPI(dateValue) : null
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: formattedDate
            })
        },

        updateResponseCheckbox(fieldId, index, checked) {
            // Emit update event to parent for checkbox
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: checked
            })
        },

        startEditResponseField(fieldId, index) {
            const responseField = this.recallData.recall_info.response_form[index]
            this.editingResponseField = { fieldId, index }
            this.tempResponseFieldLabel = responseField.key || ''


            // Set initial value based on field type
            if (responseField.type === 'CHECKBOX') {
                this.tempResponseFieldValue = responseField.value || false
            } else if (responseField.type === 'DATE') {
                this.tempResponseFieldValue = responseField.value ? this.convertDateForPicker(responseField.value) : null
            } else if (responseField.type === 'RADIO') {
                this.tempResponseFieldValue = responseField.value || ''
            } else {
                this.tempResponseFieldValue = responseField.value || ''
            }
        },

        getRadioOptions(options) {
            // Convert options object to array format for b-form-radio-group
            if (!options || typeof options !== 'object') {
                return []
            }
            return Object.keys(options).map(key => ({
                text: options[key],
                value: key
            }))
        },

        saveEditResponseField(fieldId, index) {
            const responseField = this.recallData.recall_info.response_form[index]

            // Validate label
            if (!this.tempResponseFieldLabel || !this.tempResponseFieldLabel.trim()) {
                this.showToast('Label cannot be empty', {
                    title: 'Validation Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                })
                return
            }

            // Emit updates
            const updates = []

            // Update label if changed
            if (this.tempResponseFieldLabel !== responseField.label) {
                updates.push({
                    fieldId,
                    field: 'key',
                    value: this.tempResponseFieldLabel.trim()
                })
            }

            // Update value if changed
            let valueChanged = false
            let formattedValue = this.tempResponseFieldValue

            if (responseField.type === 'date' && this.tempResponseFieldValue) {
                formattedValue = this.formatDateForAPI(this.tempResponseFieldValue)
                valueChanged = formattedValue !== responseField.value
            } else if (responseField.type === 'checkbox') {
                valueChanged = this.tempResponseFieldValue !== responseField.value
            } else {
                valueChanged = this.tempResponseFieldValue !== responseField.value
            }

            if (valueChanged) {
                updates.push({
                    fieldId,
                    field: 'value',
                    value: formattedValue
                })
            }

            // Emit all updates
            if (updates.length > 0) {
                this.$emit('response-field-update-multiple', updates, index)
            }

            // Clear editing state
            this.cancelEditResponseField()
        },

        cancelEditResponseField() {
            this.editingResponseField = null
            this.tempResponseFieldLabel = ''
            this.tempResponseFieldValue = ''
        }
    }
}